import React, { Component } from 'react';

class ForumRules extends Component {
    render() {
        return (
            <div>Forum Rules</div>
        );
    };
}

export default ForumRules;



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/ForumRules.js